exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.bar .search .write input {\n  border: 0;\n  width: 100%;\n  line-height: 1em;\n  margin: 0;\n}\n.bar .search .results {\n  position: absolute;\n  top: 80%;\n  left: 0;\n  z-index: 5;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-028be974","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/Search.vue
// module id = 2407
// module chunks = 0